module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/rank_v3.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/rank_v3.png
// module id = 1603
// module chunks = 418